import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["flowSourceType"];
import PropTypes from 'prop-types';
import * as FlowSourceTypes from 'automation-ui-flow-core/flow/FlowSourceTypes';
import ClassicFlowName from 'automation-ui-references/customer-data/ClassicFlowName';
import PlatformFlowName from 'automation-ui-references/customer-data/PlatformFlowName';
import { jsx as _jsx } from "react/jsx-runtime";
const WorkflowName = _ref => {
  let {
      flowSourceType
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const FlowNameComponent = flowSourceType === FlowSourceTypes.CLASSIC ? ClassicFlowName : PlatformFlowName;
  return /*#__PURE__*/_jsx(FlowNameComponent, Object.assign({}, rest));
};
WorkflowName.propTypes = {
  flowSourceType: PropTypes.oneOf(Object.keys(FlowSourceTypes))
};
export default WorkflowName;